import React, { useState } from 'react';

const IncomeProof = ({ onNext }) => {
  const [clickedButton, setClickedButton] = useState(null);
    const handleClick = (e) => {
      const buttonValue = e.target.value;
      setClickedButton(buttonValue);
      onNext(buttonValue);
    };
  return (
    <>
      <div className="qs-card__head">
        <h2 className="qs-card__title">
          Approved Without Income Proof?
        </h2>
      </div>
      <div className="qs-card__body">
        <p className="qs-card__sub">
          If you were unemployed or receiving benefits, did the lender still approve the credit card
          without asking for additional financial evidence? (e.g. bank statements, benefit letters, or proof of income)?
        </p>
        <div className="qs-actions">
          <button 
            type="button" 
            value="402"
            className={`qs-btn qs-btn--optn ${clickedButton === '402' ? 'btn-active' : ''}`} 
            onClick={handleClick}
          >
            Yes
          </button>
          <button 
            type="button" 
            value="403" 
            className={`qs-btn qs-btn--optn ${clickedButton === '403' ? 'btn-active' : ''}`} 
            onClick={handleClick}
          >
            No
          </button>
        </div>
      </div>
    </>
  );
};

export default IncomeProof;
